<template>
  <div id="app">
    <nav-menu/>
    <span class="section-anchor"/>

    <main>
      <transition name="fade" mode="out-in">
        <router-view ref="main"/>
      </transition>
    </main>

    <footer-bar/>
  </div>
</template>

<script>
import NavMenu from '@/components/NavMenu'
import FooterBar from '@/components/FooterBar'
import {getDefaultLocale, setHtmlLocale, setCanonicalLink} from '@/utils'

export default {
  components: {NavMenu, FooterBar},
  beforeMount () {
    var initialLocale = this.$route.params.lang || getDefaultLocale()
    this.$i18n.locale = initialLocale
    // handle html tag lang attribute
    setHtmlLocale(initialLocale)
    this.$watch('$i18n.locale', function (newVal, oldVal) {
      setHtmlLocale(newVal)
    })

    // handle canonical link
    setCanonicalLink()
    this.$watch('$route', function (newVal, oldVal) {
      setCanonicalLink()
    })
  }
}
</script>

<style src="@/css/person.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue